import './App.css';
import { Routes, Route , BrowserRouter} from 'react-router-dom';
import AboutUs from '../pages/AboutUs';
import JokerClub from '../pages/JokerClub';
import MultiShop from '../pages/MultiShop';
import Contact from '../pages/Contact';
import TransitionOverlay from '../components/TransitionOverlay';

function RouterWrapper() {
    return (
      <>
        <TransitionOverlay />
        <Routes>
          <Route path="/" element={<MultiShop />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/jockerclub" element={<JokerClub />} />
          <Route path="/contactus" element={<Contact />} />
        </Routes>
      </>
    );
  }
  
  export default RouterWrapper;